<template>
  <v-card>
    <v-card-title class="grey lighten-2 black--text mb-7">
      <v-icon class="ml-2">mdi-monitor</v-icon>
      مساحة البث المباشر
    </v-card-title>
    <!-- CONTENT -->
    <v-card-text class="pb-0">
      <v-container>
        <v-progress-linear
          v-if="loading"
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>

        <div v-else>
          <v-text-field
            dense
            outlined
            clearable
            class="mb-2"
            label="الرابط"
            prepend-icon="mdi-link"
            hint="اضغط علي x لإخفاء مساحة البث من صفحة الموقع"
            persistent-hint
            v-model="form.live_link"
          ></v-text-field>

          <v-file-input
            dense
            outlined
            accept="image/*"
            label="الصورة"
            prepend-icon="mdi-image"
            v-model="form.live_image"
          ></v-file-input>
        </div>
      </v-container>
    </v-card-text>

  <!-- ACTIONS -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" elevation="1" dark @click="update(form)">حفظ</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
export default {
  name: 'live',

  data: function () {
    return {
      form: {},
      loading: false
    }
  },


  created() {
    this.fetchLiveLink();
  },


  methods: {
    fetchLiveLink() {
      this.loading = true;

      this.axios.get('/admin/content/live-link')
        .then((response) => {
          this.form.live_link = response.data.live_link;
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب بيانات البث المباشر',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    update(form) {
      this.loading = true;

      let payload = new FormData;
      for (const property in form) {
        if (!form.hasOwnProperty(property) || form[property] === null) {
          continue;
        }
        payload.append(property, form[property]);
      }

      this.axios.post('/admin/content/live-link', payload)
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل بيانات البث المباشر بنجاح',
            color: 'success'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>